export const SMS = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
    	SMS_templates:'SMS Templates',
    	add_SMS_templates:'Add SMS Template',
    	s_no:'S.No',
    	name:'Name',
    	message:'Message',
    	action:'Action',
    	status:'Status',
    	reset:'Reset',
    	subject:'Subject',
        content:'Content',
    	template_information:'Template Information',
		delete_confrim_msg:"Are you sure you want to delete this sms?",
    },

	ar: {
    	SMS_templates:'قوالب الرسائل القصيرة',
    	add_SMS_templates:'إضافة قالب SMS',
    	s_no:'لا',
    	name:'الاسم',
    	message:'رسالة',
    	action:'عمل',
    	status:'الحالة',
    	reset:'إعادة ضبط',
    	subject:'الموضوع',
        content:'المحتوى',
    	template_information:'معلومات النموذج',
		delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذه الرسالة القصيرة؟",
    },
}